import { ArrowLeft, Mail, ChevronRight, FileText, Shield, ArrowLeftRight } from "lucide-react";
import { BottomNav } from "./bottom-nav";

interface HelpSupportPageProps {
  onBack: () => void;
  /** Opens the in-app article about swap shipping via Hub. */
  onNavigateToTrocaViaHub: () => void;
  /** Same destinations as Configurações → Sobre. */
  onNavigateToTerms: () => void;
  onNavigateToPrivacyPolicy: () => void;
  activeTab: string;
  /** Must accept any tab id BottomNav may emit (e.g. home, favorites). */
  onTabChange: (tab: string) => void;
  favoritesCount: number;
  onMenuClick: () => void;
  onPostAdClick: () => void;
  postAdBlockedByUnverifiedEmail?: boolean;
}

export function HelpSupportPage({
  onBack,
  onNavigateToTrocaViaHub,
  onNavigateToTerms,
  onNavigateToPrivacyPolicy,
  activeTab,
  onTabChange,
  favoritesCount,
  onMenuClick,
  onPostAdClick,
  postAdBlockedByUnverifiedEmail = false,
}: HelpSupportPageProps) {
  const contactOptions = [
    {
      icon: Mail,
      title: "Email",
      subtitle: "suporte@akihub.com.br",
      color: "bg-green-500",
      action: () => (window.location.href = "mailto:suporte@akihub.com.br"),
    },
  ];

  const quickLinks = [
    {
      icon: ArrowLeftRight,
      label: "Como funciona a troca via Hub",
      action: onNavigateToTrocaViaHub,
    },
    { icon: FileText, label: "Termos de Uso", action: onNavigateToTerms },
    { icon: Shield, label: "Política de Privacidade", action: onNavigateToPrivacyPolicy },
  ];

  return (
    <div className="min-h-screen bg-background pb-24">
      {/* Header */}
      <header className="bg-primary border-b border-primary sticky top-0 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-4 px-4 py-4">
            <button
              onClick={onBack}
              className="p-2 hover:bg-white/20 rounded-lg transition-colors -ml-2"
              aria-label="Voltar"
            >
              <ArrowLeft className="w-6 h-6 text-white" />
            </button>
            <h1 className="text-lg font-medium text-white">Ajuda & Suporte</h1>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-7xl mx-auto">
        {/* Contact (email only — chat & phone hidden until available) */}
        <div className="px-4 pt-6 mb-6">
          <h2 className="text-sm font-medium text-muted-foreground mb-3">Entre em Contato</h2>
          <div className="grid grid-cols-1 gap-3">
            {contactOptions.map((option, index) => {
              const Icon = option.icon;
              return (
                <button
                  key={index}
                  type="button"
                  onClick={option.action}
                  className="bg-card border border-border rounded-xl p-4 flex items-center gap-4 hover:bg-accent transition-colors"
                >
                  <div
                    className={`${option.color} w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0`}
                  >
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <div className="flex-1 text-left">
                    <div className="font-medium">{option.title}</div>
                    <div className="text-sm text-muted-foreground">{option.subtitle}</div>
                  </div>
                  <ChevronRight className="w-5 h-5 text-muted-foreground" />
                </button>
              );
            })}
          </div>
        </div>

        {/* Quick links — FAQ, chat, phone & diretrizes hidden for now */}
        <div className="px-4 mb-8">
          <h2 className="text-sm font-medium text-muted-foreground mb-3">Links Rápidos</h2>
          <div className="bg-card border border-border rounded-xl overflow-hidden">
            {quickLinks.map((link, index) => {
              const Icon = link.icon;
              return (
                <button
                  key={link.label}
                  type="button"
                  onClick={link.action}
                  className={`w-full px-4 py-4 flex items-center gap-3 hover:bg-accent transition-colors ${
                    index < quickLinks.length - 1 ? "border-b border-border" : ""
                  }`}
                >
                  <Icon className="w-5 h-5 text-muted-foreground" />
                  <span className="flex-1 text-left">{link.label}</span>
                  <ChevronRight className="w-5 h-5 text-muted-foreground" />
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <BottomNav
        activeTab={activeTab}
        onTabChange={onTabChange}
        favoritesCount={favoritesCount}
        onMenuClick={onMenuClick}
        onPostAdClick={onPostAdClick}
        postAdBlockedByUnverifiedEmail={postAdBlockedByUnverifiedEmail}
      />
    </div>
  );
}
